import { DynamicShiftStatus } from '@bemlo/enums'

import { Badge, BadgeColor } from './Badge'
import { useTranslations } from '../translate'

const STATUS_COLOR_MAP: Record<DynamicShiftStatus, BadgeColor> = {
  [DynamicShiftStatus.APPLICATION_NOT_CHOSEN]: 'danger',
  [DynamicShiftStatus.APPLIED]: 'yellow',
  [DynamicShiftStatus.SUGGESTED]: 'yellow',
  [DynamicShiftStatus.ACCEPTED]: 'lighter-green',
  [DynamicShiftStatus.AVAILABLE]: 'dark-blue',
  [DynamicShiftStatus.BOOKED]: 'darker-green',
  [DynamicShiftStatus.CANCELED]: 'grey',
  [DynamicShiftStatus.OCCUPIED]: 'grey',
  [DynamicShiftStatus.REJECTED]: 'red',
  [DynamicShiftStatus.WITHDRAWN]: 'golden-rod',
}

export type ShiftStatusBadgeProps = {
  status: DynamicShiftStatus
}

export const ShiftStatusBadge = ({ status }: ShiftStatusBadgeProps) => {
  const t = useTranslations()

  return (
    <Badge color={STATUS_COLOR_MAP[status]} size="sm">
      {t.$dynamicShiftStatus(status)}
    </Badge>
  )
}
